<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
  <div>
    <!-- 导航条 -->
    <van-sticky @scroll="scrollPage"></van-sticky>
    <div class="header_gra fixed">
      <!-- :class="{fixed: fixedHeader}" -->
      <div class="header_gra_top">
        <div class="gra_container">您好，欢迎登录捷安特GRA微学平台</div>
      </div>
      <div class="header_gra_box gra_container">
        <div class="header_gra_left">
          <router-link class="logo_wrap" :to="{name: 'Index'}">
            <div class="logo_cover image"
              v-lazy:background-image="{
                src: './static/img/gra_logo_pc.png',
                error: './static/img/gra_logo_pc.png'
              }"
            ></div>
            <!-- 捷安特GRA -->
            <div class="text">微学平台</div>
          </router-link>
          <div class="header_gra_nav">
            <div class="item_gra_nav" :class="{active: innerShowActive==8}" @click="goToHome('Index')">首页</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==1}" @click="goToHome('Selfstudy')" >自学课程</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==2}" @click="goToHome('Train')">培训中心</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==3}" @click="goToHome('Special')">专项认证</div>
            <!-- <div class="item_gra_nav" :class="{active: innerShowActive==4}" :to="{name: 'Credit'}">学分兑换</div> -->
            <!-- <div class="item_gra_nav" :class="{active: innerShowActive==4}" @click="btn_message">学分兑换</div> -->
            <div class="item_gra_nav" :class="{active: innerShowActive==4}" @click="goToHome('Credit')">学分兑换</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==5}" @click="goToHome('Driedfood')">干货社区</div>
            <!-- <div class="item_gra_nav" :class="{active: innerShowActive==6}" @click="goToHome('StudyList')">学习地图</div> -->
            <!-- <div class="item_gra_nav" :class="{active: innerShowActive==4}" @click="btn_message">学分兑换</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==5}" @click="btn_message">干货社区</div>
            <div class="item_gra_nav" :class="{active: innerShowActive==6}" @click="btn_message">学习地图</div> -->
            <div class="item_gra_nav" :class="{active: innerShowActive==7}" @click="goToHome('Lecturer')">大咖讲师</div>
          </div>
        </div>
        <div class="header_gra_right">
          <div class="header_gra_search" v-if="!innerShowActive">
            <i class="material-icons icon" @click="btn_goto_sel"></i>
            <input type="text" v-model="keyword" class="search_input" placeholder="快快搜索你喜欢的课程吧" @keyup.enter="btn_goto_sel()">
          </div>
          <!-- 购物车 -->
          <router-link class="avatar_wrap" :to="{name: 'Cart'}" v-if="$route.name == 'Credit' || $route.name == 'CreditView'">
              <van-badge :content="$store.state.cartnum" max="99">
                <div class="avatar image" style="border: none;width: 35px;height: 35px;"
                  v-lazy:background-image="{
                  src: './static/img/cartimg/shop_cart.png',
                  error: './static/img/cartimg/shop_cart.png'
                }"
                ></div>
              </van-badge>
          </router-link>
          <router-link class="avatar_wrap" :to="{name: 'MySelfstudy'}">
            <div class="avatar image"
              v-lazy:background-image="{
                src: $store.state.loginUser.avatar,
                error: './static/img/avatar.png'
              }"
            ></div>
            <!-- <div class="text">鲁瑞</div> -->
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageNav',
  components: {},
  props: ['showActive', 'showSearch'],
  data () {
    return {
      tmpName: 'PageNav',
      fixedHeader: false,//控制头部滚动浮动样式
      innerShowActive: 0,
      // searchType: true,

      keyword: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;

    //是否显示【active】
    if( typeof _this.showActive != 'undefined' ){
      _this.innerShowActive = _this.showActive;
    }

    // if( typeof _this.showSearch != 'undefined' ){
    //   _this.searchType = _this.showSearch;
    // }
  },
  mounted() {
  },
  destroyed() {},
  methods: {

    goToHome(name){
      const _this = this;
      // 清除缓存
      sessionStorage.removeItem('SET_PCDATA')
      sessionStorage.removeItem('SET_PHONEDATA')
      localStorage.removeItem('SET_sortData_lv1')
      localStorage.removeItem('SET_sortData_lv2')
      localStorage.removeItem('SET_sortData_lv3')
      _this.$router.push({ name: name });
    },

    //页面滚动
    scrollPage(data){
      const _this = this;

      _this.fixedHeader = data.isFixed;
    },

    btn_goto_sel(){
      const _this = this;

      _this.$router.push({name: 'Selfstudy', query: {keyword: _this.keyword}})
    },

    btn_message(){
      const _this = this;

      _this.$dialog.confirm({
        closeOnPopstate: true,//页面回退时自动关闭
        title: '通知',
        message: '功能暂未开放，敬请期待',
        showCancelButton: false,
        confirmButtonText: '我知道了',
      }).then(() => {
      }).catch(() => {
      });
    },
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/PageNav.vue